import React from "react";

export default function SelectedPatternsCount({ count }) {
  return (
    <div style={{ textAlign: "center" }}>{`${count} pattern${
      count === 1 ? "" : "s"
    } selected`}</div>
  );
}
